import { OnChanges, SimpleChanges } from '@angular/core';
import { Constants } from '@utils/constants';
import { Component, OnInit, OnDestroy, Input, Renderer2, Output, EventEmitter } from '@angular/core';
import { AbstractItem } from '@business/base/abstract-item';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { MatDialog } from '@angular/material/dialog';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { SimpleOrder } from '@model/simpleOrder';
import { SideEnum } from '@model/enum/side.enum';
import { Subscription } from 'rxjs';
import { ConfigService } from '@services/webFeeder/config.service';
import { MessageQuote } from '@model/webFeeder/message-quote.model';
import { BovBmfModel } from '@dto/custody-model-bov-bmf';
import { OnResizeService } from '@services/on-resize.service';
import { BilletInputConfigModel } from '@model/billet-input-config.model';

@Component({
  selector: Constants.WINDOW_NAME_BILLET_WKS,
  templateUrl: './billet-wks.component.html'
})
export class BilletWksComponent extends AbstractItem implements OnInit, OnDestroy, OnChanges {

  @Input() data: any;
  @Input() messageQuote = new MessageQuote();
  @Input() symbol: string;
  @Input() typeOrderOptions = [];
  @Input() typeOrderSelected: BilletInputConfigModel = new BilletInputConfigModel();
  @Input() listPosition: BovBmfModel = new BovBmfModel();
  @Input() isBilletFloat: boolean;
  @Input() hiddenHeaderFull: boolean;
  @Input() model: SimpleOrder = new SimpleOrder();
  @Input() strategyOptions = [];
  @Input() auctionHammer: boolean;
  @Input() financialAccount: any = {};
  @Output() openConfirmationBillit = new EventEmitter<any>();
  @Input() cardId: number;
  tabChangeSide = 0;
  isThemeDark: any;
  subscripitionChangeThemeDarkLight: Subscription;
  resizeCardBilletWksSubscripiton: Subscription;
  heightBillet = 0;

  constructor(
    _dialog: MatDialog,
    _workspaceService: WorkspaceNewService,
    _itemService: AbstractItemService,
    private _render2: Renderer2,
    private _configService: ConfigService,
    private _onResizeService: OnResizeService,
  ) {
    super(_workspaceService, _dialog, _itemService);
    this.workspaceService = _workspaceService;
    this.dialog = _dialog;
  }

  ngOnChanges(changes: SimpleChanges): void { 
    if ((changes.hiddenHeaderFull && !changes.hiddenHeaderFull.firstChange && changes.hiddenHeaderFull.previousValue !== changes.hiddenHeaderFull.currentValue)
      || changes.symbol && changes.symbol.previousValue !== changes.symbol.currentValue
      || changes.auctionHammer && changes.auctionHammer.previousValue !== changes.auctionHammer.currentValue) {
      this.setSizeCardScroll(null);
    }
  }

  ngOnInit() {
    this.tabChangeSide = this.model && this.model.side === SideEnum.SELL ? 1 : 0;
    this.subscripitionChangeThemeDarkLight = this._configService.changeThemeDarkLight$.subscribe(x => {
      this.isThemeDark = x === 1 ? true : false;
      setTimeout(() => {
        this.getConfigSideColor();
      }, 0);
    });
    setTimeout(() => {
      this.setSizeCardScroll(null);
    }, 500);
    this.resizeCardBilletWksSubscripiton = this._onResizeService.resizeCardBilletWks$
      .subscribe((res) => {
        if (res && res.type === this.data.type && res.id === this.data.id) {
          this.setSizeCardScroll(res.height);
        }
      });
  }

  setSizeCardScroll(height: number) {
    let marginBtn = 0;
    marginBtn = height ? (this.model.auctionHammer ? 175 : 140) : this.data.rows <= 2 ? (this.model.auctionHammer ? 155 : 135) : (this.model.auctionHammer ? 155 : 120);
    this.heightBillet = height ? height - marginBtn : (Constants.GRID_ROW_HEIGHT * this.data.rows) - marginBtn;
    this.heightBillet = this.hiddenHeaderFull ? this.heightBillet + 50 : this.heightBillet;
    if (document.getElementById('scroll-typeOrder-'+this.cardId)) {
      document.getElementById('scroll-typeOrder-'+this.cardId).style.height = this.heightBillet + 'px';
    }
  }

  ngOnDestroy() {
    this.resizeCardBilletWksSubscripiton.unsubscribe();
    this.unsubscribeAllSocket();
  }

  unsubscribeAllSocket() {
    if (this.subscripitionChangeThemeDarkLight) {
      this.subscripitionChangeThemeDarkLight.unsubscribe();
    }
  }

  changeTabSide($event) {
    if ($event.index === 0) {
      this.model.side = SideEnum.BUY;
      this.tabChangeSide = 0;
    } else {
      this.model.side = SideEnum.SELL;
      this.tabChangeSide = 1;
    }
    this.getConfigSideColor();
  }

  getConfigSideColor() {
    let element1: any;
    let element2: any;
    let element3: any;
    if (this.isThemeDark && document.getElementsByClassName('darkTheme')[0] && document.getElementsByClassName('darkTheme')[0].getElementsByClassName('typeOrderWks')[0]) {
      element1 = document.getElementsByClassName('darkTheme')[0].getElementsByClassName('typeOrderWks')[0].getElementsByClassName('mat-tab-label-content')[0];
      element2 = document.getElementsByClassName('darkTheme')[0].getElementsByClassName('typeOrderWks')[0].getElementsByClassName('mat-tab-label-active')[0];
      element3 = document.getElementsByClassName('darkTheme')[0].getElementsByClassName('typeOrderWks')[0].getElementsByClassName('mat-tab-label-active')[0]
        .getElementsByClassName('mat-tab-label-content')[0];
    } else if (document.getElementsByClassName('typeOrderWks')[0]) {
      element1 = document.getElementsByClassName('typeOrderWks')[0].getElementsByClassName('mat-tab-label-content')[0];
      element2 = document.getElementsByClassName('typeOrderWks')[0].getElementsByClassName('mat-tab-label-active')[0];
      element3 = document.getElementsByClassName('typeOrderWks')[0].getElementsByClassName('mat-tab-label-active')[0].getElementsByClassName('mat-tab-label-content')[0];
    }
    if (this.model.side === SideEnum.BUY) {
      this.tabChangeSide = 0;
      if (element1 && element2 && element3) {
        this._render2.removeClass(element1, 'text-sell');
        this._render2.addClass(element1, 'text-buy');
        this._render2.removeClass(element2, 'border-sell');
        this._render2.addClass(element2, 'border-buy');
        this._render2.removeClass(element3, 'text-sell');
        this._render2.addClass(element3, 'text-buy');
      }
    } else {
      this.tabChangeSide = 1;
      if (element1 && element2 && element3) {
        this._render2.removeClass(element1, 'text-buy');
        this._render2.addClass(element1, 'text-sell');
        this._render2.removeClass(element2, 'border-buy');
        this._render2.addClass(element2, 'border-sell');
        this._render2.removeClass(element3, 'text-buy');
        this._render2.addClass(element3, 'text-sell');

      }
    }
  }

  openModalConfirm(value) {
    this.openConfirmationBillit.emit(value);
    this.model = value;
    this.tabChangeSide = this.model.side === SideEnum.BUY ? 0 : 1;
  }

}
